import React, { useEffect, useState, useRef, useContext } from "react";
import axios from "axios";
import useEndpoints from "../../api/useEndpoints";
import Storages from "../../helper/storages";
import HistoryInfoCardDoing from "./historyInfoCardDoing";
import HistoryInfoRowTable from "./historyInfoRowTable";
import RowHeader from "./historyInfoRowHeader";
import ErrorHandler from "../../api/errorHandler";
import { useLocation } from "react-router-dom";
import Paths from "./../../config/paths.json";
import dashboardContext from "../../contexts/dashboardContext";
import loaderModal from '../../modals/loaderModal'
import DateComponent from "../DateComponent";
import cancelService from "./../../modals/cancelService"
import Toast from './../toast'

export default function DoingService(props) {
  var endpoints = useEndpoints();
  var parent = useRef();
  const location = useLocation();
  var dContext = useContext(dashboardContext);

  var [list, setList] = useState([]);

  const getData = () => {
    let params = {
      fromDate: props.startDate,
      toDate: props.endDate,
    };
    axios
      .get(endpoints.doingService, {
        headers: {
          "x-auth-token": Storages.getUserToken(),
        },
        params: params,
      })
      .then((res) => {
        setList(res.data.result);
      })
      .catch((e) => {
        console.log(e);
        ErrorHandler(e);
      });
  };

  useEffect(() => {
    getData();
  }, [props]);

  return (
    <>
      {location.pathname == Paths.dashboard || dContext.isMobile ? (
        // --------گزارش سرویس ها
        <div className="d-flex flex-column m-0 p-0" ref={parent}>
          {list.map((item, index) => {
            return <HistoryInfoCardDoing item={item} key={index}
              cancelService={() => {
                cancelService.show(() => {
                  var loader = loaderModal.load()
                  axios.delete(endpoints.service,
                    {
                      headers:
                      {
                        'x-auth-token': Storages.getUserToken()
                      },
                      data: { tripCode: item.tripCode }
                    }).then((res) => {
                      Toast.Success('با موفقیت لغو شد')
                      getData()
                      props.refreshPage()
                    }).catch((e) => {
                      console.log(e)
                      ErrorHandler(e)
                    }).then(() => {
                      loader.close()
                    })
                })
              }
              }
            />
          })}
        </div>
      ) : (
        <>
          <table className="table table-sm table-striped bg-light">
            <thead className="thead-dark">
              <RowHeader />
            </thead>
            <tbody className="thead-dark">
              {list.map((item, index) => {
                return <HistoryInfoRowTable item={item} />;
              })}
            </tbody>
          </table>
        </>
      )}

    </>
  );
}
